

import axios from "axios";
import React, { useEffect, useState, useCallback } from 'react';
import { useToast } from '../../hooks/ToastContext';
import config from '../../config';
import { useParams } from "react-router-dom";
function ViralShareBox({ contest_id, purl,ffrefurl,contestDetails,lang}) {

    const [viralsharedetails, setviralshareDetails] = useState({});
    const { showToast } = useToast();
    const session_member = sessionStorage.getItem('member_' + contest_id);
    let member_det = JSON.parse(session_member);
    let vshare_url;
    const { cid } = useParams();
   
    if (ffrefurl !== '' && ffrefurl !== null && typeof ffrefurl !== 'undefined') {
        vshare_url = ffrefurl +'?mid=' + member_det?.url_token;
       
    }else if(contestDetails.published_url !== '' && contestDetails.published_url !== '' && contestDetails.published_url !== null && typeof contestDetails.published_url !== 'undefined'){
     
        vshare_url = contestDetails?.published_url +'?mid=' + member_det?.url_token;

    }else if (purl !== '' && purl !== null && typeof purl !== 'undefined') {   

        vshare_url = purl +'?mid=' + member_det?.url_token;
    } else {
       // vshare_url = config.VIRAL_SHARE_URL + "/" + contest_id + "/" + member_det?.url_token;
       if(cid == null){
             vshare_url = `${window.location.origin}?mid=${member_det?.url_token}`;
       }else{
            vshare_url = `${window.location.origin}/${contest_id}?mid=${member_det?.url_token}`;
       }
    }
    
    //alert(vshare_url);
   

    const feviralShareDetails = useCallback(async () => {

        const session_member = sessionStorage.getItem('member_' + contest_id);
        if (session_member) {
            const memberDet = JSON.parse(session_member);
            try {
                let payload = {
                    contest_id: contest_id,
                    contest_member_id: memberDet.contest_member_id,

                };
                const res = await axios.post(`${config.API_URL}/get-viral-share-details`, payload);

                if (res.status === 200) {
                    //  console.log(res.data.viralshare.entry);
                    setviralshareDetails(JSON.parse(res.data.viralshare.entry));

                }
            } catch (error) {
                console.log(error);
            }
        }
    }, [contest_id]);

    useEffect(() => {
        if (contest_id) {
            feviralShareDetails();
        }
    }, [contest_id, feviralShareDetails]);

    // const copyText = () => {
    //     navigator.clipboard.writeText(vshare_url)
    //       .then(() => {
    //         showToast('success',"URL Copied");
    //       })
    //       .catch((err) => {
    //         console.error("Failed to copy text: ", err);
    //       });
    //   };

    const copyText = () => {
        const textarea = document.createElement('textarea');
        textarea.value = vshare_url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        showToast('success', "URL Copied");
    };

    return (
        <>
            {viralsharedetails.type && (
                <div className="p-4 w-full">
                    <h3 className="text-base text-center p-4 sm:px-6 lg:px-16">
                         {lang?.share_your_unique_contest || 'Share your unique contest URL with as many people as possible to increase your chances of winning!'}
                    </h3>

                    <div className="primary_light_bgcolor bg-[#E1EDF9] p-4 my-2 rounded-md w-full">
                        <div className="w-full p-2">
                            <div className="mb-2 flex justify-between items-center">
                                <label htmlFor="website-url" className="text-sm font-medium text-gray-900">
                                    {lang?.contest_url || 'Contest URL'}
                                </label>
                            </div>
                            <div className="flex flex-col sm:flex-row items-stretch relative w-full gap-2 sm:gap-0">
                                <input
                                    id="website-url"
                                    type="text"
                                    className="bg-gray-50 border border-gray-300 text-gray-500 text-sm w-full p-2 rounded-md sm:rounded-l-md sm:rounded-r-none"
                                    readOnly
                                    disabled
                                    value={vshare_url}
                                />
                                <button onClick={copyText}
                                    className="primary_btn_bg shrink-0 inline-flex items-center justify-center py-2 px-4 text-sm font-medium text-white bg-[#0274F7] rounded-md sm:rounded-r-lg sm:rounded-l-none hover:bg-white hover:text-[#0274F7] border border-[#0274F7] hover:border-[#0274F7] w-full sm:w-auto"
                                    type="button"
                                >
                                     {lang?.copy_link || 'Copy Link'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>

    );
}

export default ViralShareBox;